import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth')({
    head: () => ({
        meta: [
            {
                title: 'Sign In | Phoebe',
            },
        ],
    }),
    component: AuthLayout,
});

function AuthLayout() {
    return (
        <main className="bg-secondary/50 flex min-h-screen items-center justify-center p-4">
            <Outlet />
        </main>
    );
}
